import React, { useState } from 'react';

interface SecretKeyModalProps {
  secretKey: string;
  keyName: string;
  onClose: () => void;
}

export const SecretKeyModal: React.FC<SecretKeyModalProps> = ({ secretKey, keyName, onClose }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(secretKey);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: 'rgba(15,35,64,0.5)' }}
    >
      <div
        className="max-w-2xl w-full p-6"
        style={{
          background: 'var(--surface)',
          borderRadius: 'var(--radius-lg)',
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
        }}
      >
        <div className="mb-4">
          <h3
            className="text-xl font-semibold"
            style={{ fontFamily: 'var(--font-display)', color: 'var(--text)' }}
          >
            Token Created Successfully
          </h3>
          <p className="text-sm mt-1" style={{ color: 'var(--text-muted)' }}>Service: {keyName}</p>
        </div>

        <div
          className="rounded-lg p-4 mb-5"
          style={{
            background: '#fffbeb',
            border: '1px solid rgba(180,120,0,0.3)',
          }}
        >
          <div className="flex gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ color: '#92400e' }}>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <div>
              <p className="font-semibold text-sm mb-1" style={{ color: '#78350f' }}>Save This Token Now!</p>
              <p className="text-sm" style={{ color: '#92400e' }}>
                This is the only time you will see this token. Store it securely — you won't be able to view it again.
                If you lose this token, you will need to regenerate it.
              </p>
            </div>
          </div>
        </div>

        <div className="mb-5">
          <label
            className="block text-xs font-semibold uppercase tracking-wider mb-2"
            style={{ color: 'var(--text-muted)' }}
          >
            Service Token
          </label>
          <div className="flex gap-2">
            <input
              type="text"
              value={secretKey}
              readOnly
              className="flex-1 px-3 py-2 font-mono text-sm rounded-md"
              style={{
                background: 'var(--bg)',
                border: '1px solid var(--border)',
                color: 'var(--text)',
                outline: 'none',
              }}
            />
            <button
              type="button"
              onClick={copyToClipboard}
              className="px-4 py-2 text-sm font-medium text-white rounded-md transition-colors"
              style={{ background: copied ? 'var(--success)' : 'var(--navy)' }}
              onMouseEnter={e => { if (!copied) (e.currentTarget as HTMLButtonElement).style.background = 'var(--navy-light)' }}
              onMouseLeave={e => { if (!copied) (e.currentTarget as HTMLButtonElement).style.background = 'var(--navy)' }}
            >
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>
        </div>

        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 text-sm font-medium text-white rounded-md transition-colors"
            style={{ background: 'var(--navy)' }}
            onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.background = 'var(--navy-light)'}
            onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.background = 'var(--navy)'}
          >
            I've Saved the Token
          </button>
        </div>
      </div>
    </div>
  );
};
